import { isAvailable, isNetworkInStock } from './availability';
import { getCheapestVariantId, getFirstMatchingVariantId, getMatchingVariants } from './chooseVariant';
import { sizeOrder } from './constants';
import {
  getSelectedColorSwatchIndex,
  getUniqueColorVariants,
  getUniqueColorVariantsSLP,
} from './getUniqueColorVariants';
import { getUniqueOperators } from './getUniqueOperators';
import { getUniqueAvailableSizes, getUniqueSizes, isSizesValid } from './getUniqueSizes';
import { getVariant } from './getVariant';

const getMeasurements = ({ product, productMeasurement }) => {
  if (productMeasurement) {
    const { format, unit } = productMeasurement;
    if (!format || !unit) {
      return null;
    }
    return {
      formato: format,
      'unidad-de-medida': unit,
      skuminsaleqty: productMeasurement?.skuminsaleqty,
    };
  }

  const { variants, currentVariant } = product;
  if (!variants?.length) {
    return null;
  }
  const variant = getVariant(variants, currentVariant);
  if (!variant?.attributes?.measurement) {
    return null;
  }
  const { measurement } = variant.attributes;
  return {
    formato: measurement?.formato,
    'unidad-de-medida': measurement?.['unidad-de-medida'],
    skuminsaleqty: measurement?.skuminsaleqty,
  };
};

export {
  getCheapestVariantId,
  getFirstMatchingVariantId,
  getMatchingVariants,
  getMeasurements,
  getSelectedColorSwatchIndex,
  getUniqueAvailableSizes,
  getUniqueColorVariants,
  getUniqueColorVariantsSLP,
  getUniqueOperators,
  getUniqueSizes,
  getVariant,
  isAvailable,
  isNetworkInStock,
  isSizesValid,
  sizeOrder,
};
